module.exports = __webpack_public_path__ + "assets/img/chop.868e0769.svg";